module.exports = __webpack_public_path__ + "img/just_logo_light3.69a6a4e8.png";